import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import classNames from 'classnames';

import RaisedButton from 'material-ui/RaisedButton';
import { TableRow, TableRowColumn } from 'material-ui/Table';

import { banUserById, unbanUserById } from 'actions/users';

import styles from 'styles';

import { approveUser, disapproveUser } from '../../../services/companies';

class Row extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            companyRole: this.props.companyRole,
            isMemberApproved: false,
        }

        this.setRoleBgColor = this.setRoleBgColor.bind(this);
        this.toggleCompanyMemberStatus = this.toggleCompanyMemberStatus.bind(this);
    }

    setRoleBgColor(role) {
        if (role === 'manager') return 'rgb(50, 168, 82)';
        if (role === 'owner') return 'rgb(245, 188, 66)';
        if (role === 'pending' || role  === 'unset') return 'rgb(135, 66, 245)';
    }
  
    async toggleCompanyMemberStatus() {
        const member = this.props.item;

        if (this.props.isApproved || this.props.item.user.approved) {
            await disapproveUser(member);

            this.props.updateCompanyMemberStatus(member);
            return;
        }

        await approveUser(member);

        this.props.updateCompanyMemberStatus(member);
    }
    

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState !== this.state) return true;

        if (nextProps !== this.props) {
            this.setState(() => ({
                companyRole: nextProps.companyRole,
            }));
            
            return true;
        }

        return false;
    }

    render() {
        const { item, banUserById, unbanUserById, companyRoleMode, isApproved, isFilteredByCompany } = this.props;
        const isVerifiedEmail = item.user ? item.user.emailVerified : item.emailVerified;
        const emailStatusClass = classNames({
            'verify-email-success': isVerifiedEmail,
            'verify-email-failure': !isVerifiedEmail,
        });

        return (
            <TableRow>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {
                        item.name || item.user && item.user.name
                    }
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnBigCSS}>
                  <Link
                    to={`/users/${item.user && item.user._id || item._id}`}
                    className='common-link'
                  >
                    {item.email || item.user && item.user.email}
                  </Link>
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {
                        item.role
                    }
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {
                        isFilteredByCompany ? 
                            new Date(item.user && item.user.createdAt).toLocaleDateString() : 
                            new Date(item.createdAt).toLocaleDateString()
                    }
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {
                        item.company && item.company.name
                    }
                </TableRowColumn>
                {companyRoleMode && this.props.isFilteredByCompany ? 
                    <TableRowColumn>
                        <RaisedButton 
                            label={this.state.companyRole}
                            labelColor="#fff"
                            backgroundColor={this.setRoleBgColor(this.state.companyRole)}
                            onClick={() => this.props.toggleCompanyRole(item)}
                        />
                    </TableRowColumn> : 
                    null
                }
                <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                    <div className={emailStatusClass}>
                        email
                        {isVerifiedEmail ? ' is ' : ' isn\'t '}
                        verified
                    </div>
                </TableRowColumn> 
                <TableRowColumn style={styles.tableHeaderColumnSmallCSS} style={{textAlign: 'center', padding: '0'}}>
                    <RaisedButton 
                        backgroundColor={isApproved ? 'rgb(250, 76, 52)' : 'rgb(164, 198, 57)'}
                        label={isApproved ? 'Disapprove' : 'Approve'}
                        labelColor="#fff"
                        onClick={this.toggleCompanyMemberStatus}
                        disabled={isFilteredByCompany ? false : true}
                    />
                </TableRowColumn> 
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {
                        !item.banAt
                            ?
                            <RaisedButton
                                label='ban'
                                onClick={() => {
                                    banUserById(item);
                                }}
                                secondary
                            />
                            :
                            <RaisedButton
                                label='unban'
                                onClick={() => {
                                    unbanUserById(item);
                                }}
                                primary
                            />
                    }
                </TableRowColumn>
            </TableRow>
        );
    }
}

export default connect(
    (state, { item }) => {
        return {
            item,
        };
    },
    dispatch => bindActionCreators({
        banUserById,
        unbanUserById
    }, dispatch),
)(Row);



// WEBPACK FOOTER //
// ./app/components/Users/BanList/Row.jsx